export default "__VITE_ASSET__B4yp5rXb__"